module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-demi-49f703b7.woff";